import { useState, useEffect, useCallback } from "react";
import { API, graphqlOperation } from "aws-amplify";
import "react-quill/dist/quill.snow.css";
import * as queries from "../../graphql/queries";
import { useNavigate } from "react-router-dom";
import "./PrivacyPolicy.css";
import { Table } from "../Table/Table";
import { PolicyType, getPolicyType } from "./PrivacyPolicType";
import { GraphQLResult } from "@aws-amplify/api-graphql";

export const PrivacyPolicy = () => {
  const [policyList, setPolicyList] = useState([] as PolicyType[]);
  const [filteredPolicyList, setFilteredPolicyList] = useState<any>([]);

  const navigate = useNavigate();

  const fetchPolicies = async () => {
    const policies = (await API.graphql(
      graphqlOperation(queries.getPolicy)
    )) as GraphQLResult<getPolicyType>;
    setPolicyList(policies?.data?.getPolicy);
    filterPolicy(policies);
  };

  const filterPolicy = useCallback(
    async (policies) => {
      const filteredPolicies = policies?.data?.getPolicy?.map((policy) => {
        return { ...policy, Active: !policy.isActive ? "❌" : "✅" };
      });
      setFilteredPolicyList(filteredPolicies);
      console.log(filteredPolicyList);
    },
    [policyList]
  );

  const selectPolicy = (row) => {
    navigate(`/policy/${row.id}`);
  };

  useEffect(() => {
    fetchPolicies();
  }, []);

  return (
    <div className="page-container">
      <div className="title">Privacy Policies</div>
      <div style={{ display: "flex", flex: 1 }}>
        <Table
          tableRows={filteredPolicyList}
          excludeKeys={["id", "isActive"]}
          pagination={10}
          handleSelect={selectPolicy}
        />
      </div>
    </div>
  );
};
